import { createSlice } from "@reduxjs/toolkit";

const rfisColorsSlice = createSlice({
  name: "rfisColor",
  initialState: {
    rfis: [],
  },
  reducers: {
    setRFIs: (state, action) => {
      state.rfis = action.payload;
    },
  },
});

export const { setRFIs } = rfisColorsSlice.actions;
export default rfisColorsSlice.reducer;
